// extracted by mini-css-extract-plugin
module.exports = {"email__wrapper":"s_bd","email__text":"s_bf header button"};